import { gql } from "@apollo/client";

// One department's title, for a page that only names it.
export default gql`
  query getDepartmentTitleQuery($teamId: Int!) {
    team(teamId: $teamId) {
      id
      title
    }
  }
`;
